// ============================================
// NODE ONBOARDING CONSTANTS
// Méthode Node - Parcours 7 jours
// ============================================

// ---- PRODUITS NODE ----
export const NODE_PRODUCTS = {
  DIAGNOSTIC: {
    id: 'diagnostic',
    name: 'Node Diagnostic',
    description: 'Analyse complète de vos besoins et livraison d\'un Blueprint personnalisé',
    duration: '5-10 jours',
    price: 3000,
    deductible: true, // Déductible du NodeOS
    deliverable: 'Blueprint Node',
    includes: [
      'Analyse des flux opérationnels',
      'Audit des données et relations',
      'Recommandations d\'automatisation',
      'Blueprint personnalisé',
      'Recommandation NodeOS',
    ],
    excludes: [
      'Implémentation',
      'Formation',
      'Support continu',
    ],
  },
  STARTER: {
    id: 'starter',
    name: 'NodeOS Starter',
    description: 'Pour les équipes qui démarrent leur transformation digitale',
    monthlyPrice: 299,
    setupPrice: 1990,
    maxUsers: 5,
    includes: ['3 modules', 'Support email', '1 automatisation'],
  },
  OPERATIONS: {
    id: 'operations',
    name: 'NodeOS Operations',
    description: 'Pour les PME avec des processus établis à optimiser',
    monthlyPrice: 599,
    setupPrice: 3990,
    maxUsers: 15,
    includes: ['6 modules', 'Support prioritaire', '5 automatisations', 'API access'],
  },
  SCALE: {
    id: 'scale',
    name: 'NodeOS Scale',
    description: 'Pour les entreprises en croissance avec des besoins avancés',
    monthlyPrice: 1299,
    setupPrice: 7990,
    maxUsers: 50,
    includes: ['Tous les modules', 'Support dédié', 'Automatisations illimitées', 'SSO', 'API avancée'],
  },
};

// ---- STATUTS CLIENT ----
export const CLIENT_STATUS = {
  LEAD: 'LEAD',  
  QUALIFIED: 'QUALIFIED',      
  DIAGNOSTIC_PENDING: 'DIAGNOSTIC_PENDING', 
  DIAGNOSTIC_ACTIVE: 'DIAGNOSTIC_ACTIVE', 
  BLUEPRINT_READY: 'BLUEPRINT_READY', 
  CLIENT_ACTIVE: 'CLIENT_ACTIVE', 
  GO_LIVE: 'GO_LIVE',             
  OPTIMIZATION: 'OPTIMIZATION',      
  CHURNED: 'CHURNED',  
};

// ---- ÉTATS D'ONBOARDING ----
export const ONBOARDING_STATES = {
  INIT: 'INIT',
  QUALIFICATION: 'QUALIFICATION',
  DIAGNOSTIC_INTRO: 'DIAGNOSTIC_INTRO',
  DIAGNOSTIC_CONTEXT: 'DIAGNOSTIC_CONTEXT',  
  DIAGNOSTIC_FLOWS: 'DIAGNOSTIC_FLOWS',
  DIAGNOSTIC_DATA: 'DIAGNOSTIC_DATA',  
  DIAGNOSTIC_AUTOMATION: 'DIAGNOSTIC_AUTOMATION',
  DIAGNOSTIC_GOALS: 'DIAGNOSTIC_GOALS',  
  DIAGNOSTIC_COMPLETE: 'DIAGNOSTIC_COMPLETE',
  BLUEPRINT_OVERVIEW: 'BLUEPRINT_OVERVIEW',
  BLUEPRINT_PREVIEW: 'BLUEPRINT_PREVIEW',
  PRICING_REVIEW: 'PRICING_REVIEW',
  SIGNATURE: 'SIGNATURE',
  ONBOARDING_WELCOME: 'ONBOARDING_WELCOME',
  ONBOARDING_PROGRESS: 'ONBOARDING_PROGRESS',
  FIRST_VALUE: 'FIRST_VALUE',
  FIRST_VALUE_COMPLETE: 'FIRST_VALUE_COMPLETE',
  OPTIMIZATION: 'OPTIMIZATION',
  GOVERNANCE: 'GOVERNANCE',
  GO_LIVE: 'GO_LIVE',
  COMPLETED: 'COMPLETED',
};

// ---- SECTIONS DU DIAGNOSTIC (8 Niveaux - Machine à comprendre l'entreprise) ----
export const DIAGNOSTIC_SECTIONS = [
  {
    id: 'identity',
    state: 'DIAGNOSTIC_CONTEXT',
    title: 'Identité & Maturité',
    description: 'Situer l\'entreprise avant d\'entrer dans les processus',
    icon: '🏛️',
    estimatedMinutes: 5,
  },
  {
    id: 'flows',
    state: 'DIAGNOSTIC_FLOWS',
    title: 'Flux de valeur',
    description: 'Identifier les processus qui créent de la valeur',
    icon: '🔄',
    estimatedMinutes: 8,
  },
  {
    id: 'entities',
    state: 'DIAGNOSTIC_DATA',
    title: 'Entités & Données',
    description: 'Identifier ce qui existe vraiment comme entités',
    icon: '📦',
    estimatedMinutes: 6,
  },
  {
    id: 'tools',
    state: 'DIAGNOSTIC_DATA',
    title: 'Logiciels externes',
    description: 'Identifier les outils externes utilisés',
    icon: '🔌',
    estimatedMinutes: 5,
  },
  {
    id: 'rules',
    state: 'DIAGNOSTIC_AUTOMATION',
    title: 'Règles & Logique',
    description: 'Comprendre ce qui est toujours vrai vs parfois vrai',
    icon: '⚖️',
    estimatedMinutes: 4,
  },
  {
    id: 'visualization',
    state: 'DIAGNOSTIC_GOALS',
    title: 'Visualisation & Pilotage',
    description: 'Comment voir l\'information',
    icon: '📊',
    estimatedMinutes: 4,
  },
  {
    id: 'automation',
    state: 'DIAGNOSTIC_GOALS',
    title: 'Automatisation',
    description: 'Opportunités d\'automatisation',
    icon: '⚡',
    estimatedMinutes: 5,
  },
  {
    id: 'access',
    state: 'DIAGNOSTIC_GOALS',
    title: 'Contrôle & Accès',
    description: 'Qui voit quoi, qui modifie quoi',
    icon: '🔐',
    estimatedMinutes: 4,
  },
  {
    id: 'pain',
    state: 'DIAGNOSTIC_GOALS',
    title: 'Points de douleur',
    description: 'Pertes de temps et frustrations',
    icon: '💢',
    estimatedMinutes: 4,
  },
];

// ---- CHECKLIST PREMIÈRE VALEUR ----
export const FIRST_VALUE_CHECKLIST = [
  { id: 'create_client', label: 'Créer votre premier client', icon: '👤', estimatedMinutes: 2 },
  { id: 'create_project', label: 'Créer votre premier dossier/projet', icon: '📁', estimatedMinutes: 3 },
  { id: 'create_invoice', label: 'Créer votre première facture', icon: '📄', estimatedMinutes: 2 },
  { id: 'send_portal', label: 'Envoyer un accès portail client', icon: '🌐', estimatedMinutes: 1 },
  { id: 'view_dashboard', label: 'Consulter votre dashboard', icon: '📊', estimatedMinutes: 1 },
];

// ---- TIMELINE SIDEBAR ----
export const TIMELINE_STEPS = [
  { 
    key: 'QUALIFICATION', 
    label: 'Qualification', 
    icon: '📋',
    day: 1,
    states: ['INIT', 'QUALIFICATION'],
  },
  { 
    key: 'DIAGNOSTIC', 
    label: 'Diagnostic', 
    icon: '🔍',
    day: 2,
    states: [
      'DIAGNOSTIC_INTRO', 
      'DIAGNOSTIC_CONTEXT',
      'DIAGNOSTIC_FLOWS',
      'DIAGNOSTIC_DATA',
      'DIAGNOSTIC_AUTOMATION',
      'DIAGNOSTIC_GOALS',
      'DIAGNOSTIC_COMPLETE',
    ],
    subSteps: DIAGNOSTIC_SECTIONS.map(s => ({ key: s.id, label: s.title, icon: s.icon })),
  },
  { 
    key: 'ANALYSIS', 
    label: 'Analyse Node', 
    icon: '🔬',
    day: 3,
    states: ['SCHEDULE_BLUEPRINT_CALL', 'ANALYSIS_IN_PROGRESS'],
  },
  { 
    key: 'BLUEPRINT', 
    label: 'Blueprint', 
    icon: '🏗️',
    day: 4,
    states: ['BLUEPRINT_OVERVIEW', 'BLUEPRINT_PREVIEW', 'PRICING_REVIEW'],
  },
  { 
    key: 'SIGNATURE', 
    label: 'Contrat', 
    icon: '✍️',
    day: 5,
    states: ['SIGNATURE'],
  },
  { 
    key: 'ONBOARDING', 
    label: 'Création du système', 
    icon: '⚙️',
    day: 6,
    states: ['ONBOARDING_WELCOME', 'ONBOARDING_PROGRESS', 'FIRST_VALUE', 'FIRST_VALUE_COMPLETE'],
  },
  { 
    key: 'OPTIMIZATION', 
    label: 'Révision & Optimisation', 
    icon: '⚡',
    day: 7,
    states: ['OPTIMIZATION', 'GOVERNANCE', 'GO_LIVE', 'COMPLETED'],
  },
];

// ---- MAPPING ÉTAT → INDEX TIMELINE ----
export const STATE_TO_STEP_INDEX = Object.fromEntries(
  TIMELINE_STEPS.flatMap((step, index) => 
    step.states.map(state => [state, index])
  )
);

// ---- EMAILS AUTOMATIQUES ----
export const EMAIL_TEMPLATES = {
  QUALIFICATION_ACCEPTED: {
    subject: 'Bienvenue dans le Diagnostic Node',
    trigger: 'QUALIFICATION → DIAGNOSTIC_INTRO',
  },
  DIAGNOSTIC_STARTED: {
    subject: 'Votre Diagnostic Node a commencé',
    trigger: 'DIAGNOSTIC_INTRO → DIAGNOSTIC_CONTEXT',
  },
  DIAGNOSTIC_REMINDER: {
    subject: 'Complétez votre Diagnostic Node',
    trigger: '48h sans activité en DIAGNOSTIC_*',
  },
  DIAGNOSTIC_COMPLETE: {
    subject: 'Votre Diagnostic Node est terminé',
    trigger: 'DIAGNOSTIC_GOALS → DIAGNOSTIC_COMPLETE',
  },
  BLUEPRINT_READY: {
    subject: 'Votre système Node — clair, structuré, prêt',
    trigger: 'DIAGNOSTIC_COMPLETE → BLUEPRINT_OVERVIEW',
  },
  SIGNATURE_INVITE: {
    subject: 'Finalisez votre accès à Node',
    trigger: 'PRICING_REVIEW → SIGNATURE',
  },
  WELCOME_CLIENT: {
    subject: 'Bienvenue chez Node — voici la suite',
    trigger: 'SIGNATURE → ONBOARDING_WELCOME',
  },
  ONBOARDING_DAY1: {
    subject: 'Votre première action dans Node',
    trigger: 'ONBOARDING_PROGRESS (J+1)',
  },
  ONBOARDING_DAY3: {
    subject: 'Voici ce que vous pouvez déjà faire',
    trigger: 'ONBOARDING_PROGRESS (J+3)',
  },
  ONBOARDING_DAY7: {
    subject: 'On optimise maintenant',
    trigger: 'ONBOARDING_PROGRESS (J+7)',
  },
  OPTIMIZATION_SESSION: {
    subject: 'On affine votre système',
    trigger: 'FIRST_VALUE_COMPLETE → OPTIMIZATION',
  },
  GO_LIVE: {
    subject: 'Votre système Node est officiellement en production',
    trigger: 'GOVERNANCE → GO_LIVE',
  },
  FOLLOWUP_30: {
    subject: 'Comment se passe Node ?',
    trigger: 'GO_LIVE (J+30)',
  },
  TESTIMONIAL_REQUEST: {
    subject: 'Partagez votre expérience Node',
    trigger: 'GO_LIVE (J+45)',
  },
};

// ---- THEME GLASSMORPHISM ----
export const GLASS_THEME = {
  background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
  glassBg: 'rgba(255, 255, 255, 0.08)',
  glassBgHover: 'rgba(255, 255, 255, 0.12)',
  glassBorder: 'rgba(255, 255, 255, 0.18)',
  glassShadow: '0 8px 32px rgba(0, 0, 0, 0.37)',
  blur: 'blur(20px)',
  accentPrimary: '#6366f1',
  accentSecondary: '#8b5cf6',
  accentSuccess: '#10b981',
  accentWarning: '#f59e0b',
  accentError: '#ef4444',
  textPrimary: '#000000',
  textSecondary: 'rgba(5, 5, 5, 0.7)',
  textMuted: 'rgba(106, 106, 106, 0.5)',
};

/**
 * Create a dynamic theme based on branding colors
 */
export const createDynamicTheme = (branding = {}) => {
  const mainColor = branding?.mainColor || GLASS_THEME.accentPrimary;
  const secColor = branding?.secColor || GLASS_THEME.accentSecondary;
  
  return {
    ...GLASS_THEME,
    background: `linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 30%, ${mainColor}20 60%, #16162a 100%)`,
    accentPrimary: mainColor,
    accentSecondary: secColor,
    accentGradient: `linear-gradient(135deg, ${mainColor} 0%, ${secColor} 100%)`,
    accentGradientHover: `linear-gradient(135deg, ${mainColor}dd 0%, ${secColor}dd 100%)`,
    glassBorder: `${mainColor}30`,
    glassBorderHover: `${mainColor}50`,
    glowShadow: `0 0 40px ${mainColor}20`,
    buttonShadow: `0 4px 20px ${mainColor}40`,
  };
};

// ---- ANIMATIONS ----
export const ANIMATION_VARIANTS = {
  fadeIn: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
    transition: { duration: 0.4, ease: 'easeOut' },
  },
  slideIn: {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
    transition: { duration: 0.3, ease: 'easeOut' },
  },
  scaleIn: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
    transition: { duration: 0.3, ease: 'easeOut' },
  },
  stagger: {
    animate: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  },
};

// ============================================
// PORTAIL CLIENT — PHASES & DÉBLOCAGE DES ESPACES
// ============================================

export const SPACE_PHASES = {
  ALWAYS: 'always',   // Avant signature, toujours disponible
  SIGNED: 'signed',   // Après signature
  GOLIVE: 'golive',   // Après Go Live
};

// Seuils de déblocage exprimés en index de TIMELINE_STEPS
export const UNLOCK_INDEX = {
  BLUEPRINT: STATE_TO_STEP_INDEX['BLUEPRINT_OVERVIEW'] ?? 3,
  SIGNED: STATE_TO_STEP_INDEX['ONBOARDING_WELCOME'] ?? 5,
};

// La mise en ligne est un état (compte livré), pas une étape de timeline.
export const GOLIVE_STATES = ['GO_LIVE', 'COMPLETED'];

/**
 * Un espace est-il débloqué selon l'avancement maximal atteint ?
 * @param {string} phase - SPACE_PHASES
 * @param {number} maxIndex - STATE_TO_STEP_INDEX[maxReachedState]
 * @param {string} maxReachedState - état maximal atteint (pour la phase GOLIVE)
 */
export const isPhaseUnlocked = (phase, maxIndex = 0, maxReachedState = null) => {
  if (phase === SPACE_PHASES.SIGNED) return maxIndex >= UNLOCK_INDEX.SIGNED;
  if (phase === SPACE_PHASES.GOLIVE) return GOLIVE_STATES.includes(maxReachedState);
  return true;
};

// ============================================
// SECTIONS DU PORTAIL ↔ ÉTAPES DE TIMELINE
// ============================================
// Chaque section "flux" regroupe des étapes de la timeline (sous-navigation interne).
export const SECTION_STEP_KEYS = {
  qualification: ['QUALIFICATION', 'DIAGNOSTIC', 'ANALYSIS'],
  account: ['BLUEPRINT', 'SIGNATURE'],
  projects: ['ONBOARDING', 'OPTIMIZATION'],
};

// Retourne l'id de section qui contient l'état courant.
export const getSectionForState = (currentState) => {
  const stepIndex = STATE_TO_STEP_INDEX[currentState];
  if (stepIndex === undefined) return 'qualification';
  const stepKey = TIMELINE_STEPS[stepIndex]?.key;
  const entry = Object.entries(SECTION_STEP_KEYS).find(([, keys]) => keys.includes(stepKey));
  return entry ? entry[0] : 'qualification';
};

// Retourne les étapes (objets TIMELINE_STEPS) d'une section.
export const getStepsForSection = (sectionId) => {
  const keys = SECTION_STEP_KEYS[sectionId] || [];
  return TIMELINE_STEPS.filter((s) => keys.includes(s.key));
};

// L'état courant appartient-il à la section ?
export const isStateInSection = (currentState, sectionId) =>
  (SECTION_STEP_KEYS[sectionId] || []).includes(TIMELINE_STEPS[STATE_TO_STEP_INDEX[currentState]]?.key);

// ============================================
// TYPES DE REQUÊTES (structuredTasks) & PROJETS
// ============================================

// group: 'project' -> espace Projets, 'connectors' -> espace Connecteurs et accès
// behavesAs: type de base réutilisé pour le rendu/la complétion côté portail.
export const REQUEST_TYPES = {
  file_upload: { id: 'file_upload', label: 'Images & fichiers', icon: '🖼️', cta: 'Téléverser', group: 'project' },
  booking: { id: 'booking', label: 'Rencontre', icon: '📅', cta: 'Planifier', group: 'project' },
  question: { id: 'question', label: 'Question', icon: '💬', cta: 'Répondre', group: 'project' },
  note: { id: 'note', label: 'Information', icon: '📝', cta: 'Voir', group: 'project' },
  api_key: { id: 'api_key', label: 'Identifiants', icon: '🔑', cta: 'Ajouter la clé', group: 'connectors' },
  access: { id: 'access', label: 'Accès', icon: '🔓', cta: 'Donner accès', group: 'connectors' },
  connector_connection: { id: 'connector_connection', label: 'Connexion connecteur', icon: '🔌', cta: 'Connecter', group: 'connectors', behavesAs: 'access' },
  connector_access: { id: 'connector_access', label: 'Accès connecteur', icon: '🔐', cta: 'Donner accès', group: 'connectors', behavesAs: 'access' },
  technical_access: { id: 'technical_access', label: 'Accès technique', icon: '🛠️', cta: 'Donner accès', group: 'connectors', behavesAs: 'access' },
  document_request: { id: 'document_request', label: 'Document à fournir', icon: '📄', cta: 'Téléverser', group: 'project', behavesAs: 'file_upload' },
  approval: { id: 'approval', label: 'Validation', icon: '✅', cta: 'Valider', group: 'project', behavesAs: 'question' },
  decision_validation: { id: 'decision_validation', label: 'Décision à valider', icon: '⚖️', cta: 'Valider', group: 'project', behavesAs: 'question' },
};

export const PROJECT_TYPES = {
  initial: { id: 'initial', label: 'Conception initiale' },
  change_request: { id: 'change_request', label: 'Demande de changement' },
};

/** Structure BOS Projet/Mandat sur le compte Node (collection grids) */
export const NODE_PROJECT_STRUCTURE_ID = 'dIA0D0B3zW2n9Vgo8cRL';

export const TICKET_CATEGORIES = [
  { value: 'account_change', label: 'Changement au compte' },
  { value: 'admin_service', label: 'Administration/Service client' },
  { value: 'support', label: 'Support' },
];

// Compte Node (admin platform)
export const NODE_ADMIN_BUSINESS_ID = 'EUxGprAXFzBGWDNtdjNl';

// Réexport liaisons (source: utils/entityLinks)
export {
  ENTITY_LINK_TYPES as TICKET_LINK_TYPES,
  MAX_ENTITY_LINKS as MAX_PROJECT_LINKS,
} from '../../utils/entityLinks';

/**
 * Aplatit les structuredTasks (globalTasks + tasksByStructure) en une liste simple.
 */
export const flattenStructuredTasks = (progress) => {
  const st = progress?.structuredTasks;
  if (!st) return [];
  const globalTasks = (st.globalTasks || []).map((t) => ({ ...t, structureName: 'Global' }));
  const structureTasks = (st.tasksByStructure || []).flatMap((sg) =>
    (sg.tasks || []).map((t) => ({ ...t, structureName: sg.structureName }))
  );
  return [...globalTasks, ...structureTasks];
};

// ============================================
// DESIGN TOKENS (partagés par le portail)
// ============================================

export const getDesignTokens = (isDarkMode, accentPrimary = '#6366f1') => ({
  text: {
    primary: isDarkMode ? '#ffffff' : '#0f172a',
    secondary: isDarkMode ? 'rgba(255,255,255,0.7)' : '#475569',
    muted: isDarkMode ? 'rgba(255,255,255,0.45)' : '#94a3b8',
  },
  bg: {
    card: isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.8)',
    cardHover: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(255,255,255,0.95)',
    subtle: isDarkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
  },
  border: {
    default: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)',
    hover: isDarkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.1)',
    accent: `${accentPrimary}40`,
  },
  status: {
    success: '#10b981',
    warning: '#f59e0b',
    error: '#f87171',
    info: accentPrimary,
  },
  shadow: {
    sm: isDarkMode ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.04)',
    md: isDarkMode ? '0 4px 16px rgba(0,0,0,0.4)' : '0 4px 16px rgba(0,0,0,0.06)',
    glow: (color) => `0 0 20px ${color}20`,
  },
});
